<div id="backgroundImage">
  <div id="cotraContainer" class="container">
    <div id="loginContainer" class="row justify-content-center">
      <div class="col-10 col-sm-8 col-md-6 col-lg-6 col-xl-6">
        <form id="passwordForm">
          <div class="loginItem unselectable subhead">{{translation.ChangeYourCotraPortalPassword}}</div>
          <mat-form-field class="passwordItem">
            <input matInput placeholder="{{translation.NewPassword}}" (keyup.enter)="changePassword()" [(ngModel)]="pwd1" type="password" name="pwd1" required [disabled]="disabled">
          </mat-form-field>
          <mat-form-field class="passwordItem">
            <input matInput placeholder="{{translation.RepeatPassword}}" (keyup.enter)="changePassword()" [(ngModel)]="pwd2" type="password" name="pwd2" required [disabled]="disabled">
          </mat-form-field>
          <div id="passwordButton" class="loginItem subhead whiteText unselectable" (keyup.enter)="changePassword()" (click)="changePassword()" disabled="{{disabled}}">{{translation.Save}}</div>
        </form>
      </div>
    </div>
  </div>
</div>
